import { render } from "./KnowMore.vue?vue&type=template&id=0d35d258"
import script from "./KnowMore.vue?vue&type=script&lang=js"
export * from "./KnowMore.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__